import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import blogList from '../data/blog/blog-list.json';
import { photoAlbums } from '../data/photoAlbums';
import { markdownToHtml, loadMarkdownContent } from '../utils/markdown';

const BlogPost = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [postContent, setPostContent] = useState('');
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleRandomPost = () => {
    const activePosts = blogList.filter(p => p.active !== false);
    if (activePosts.length > 0) {
      const randomIndex = Math.floor(Math.random() * activePosts.length);
      const randomPost = activePosts[randomIndex];
      navigate(`/blog/${randomPost.id}`);
    }
  };

  useEffect(() => {
    // Find the blog post by slug (which now matches the id exactly)
    const foundPost = blogList.find(p => p.id === slug);
    setPost(foundPost);

    if (foundPost) {
      // Load and convert markdown content
      loadMarkdownContent(foundPost).then(content => {
        const htmlContent = markdownToHtml(content, foundPost);
        setPostContent(htmlContent);
      });
    }

    setLoading(false);
  }, [slug]);

  if (loading) {
    return (
      <section id="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2>Loading...</h2>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!post) {
    return (
      <section id="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2>Blog Post Not Found</h2>
              <hr className="star-primary" />
              <p>The blog post you're looking for doesn't exist.</p>
              <Link to="/blog" className="btn btn-primary">
                Back to Blog
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="about" className="blog-post-page">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h2>{post.title}</h2>
            <hr className="star-primary" />
            <div className="blog-post-meta" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
              <span className="blog-post-date">{new Date(post.date).toLocaleDateString()}</span>

              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '5px' }}>
                {(post.tags || []).map((tag, index) => (
                  <Link
                    key={`tag-${index}`}
                    to={`/blog?tag=${encodeURIComponent(tag)}`}
                    className="filter-label"
                  >
                    {tag}
                  </Link>
                ))}

                {(post.cities || []).map((city, index) => (
                  <Link
                    key={`city-${index}`}
                    to={`/blog?city=${encodeURIComponent(city)}`}
                    className="filter-label filter-city"
                  >
                    {city}
                  </Link>
                ))}

                {(post.countries || []).map((country, index) => (
                  <Link
                    key={`country-${index}`}
                    to={`/blog?country=${encodeURIComponent(country)}`}
                    className="filter-label filter-country"
                  >
                    {country}
                  </Link>
                ))}

                {(post.continents || []).map((continent, index) => (
                  <Link
                    key={`continent-${index}`}
                    to={`/blog?continent=${encodeURIComponent(continent)}`}
                    className="filter-label filter-continent"
                  >
                    {continent}
                  </Link>
                ))}

                <span
                  className="btn btn-success"
                  onClick={handleRandomPost}
                  style={{ cursor: 'pointer', backgroundColor: '#5cb85c', color: 'white' }}
                  title="Go to random post"
                >
                  <i className="fa fa-random"></i>
                </span>
              </div>

              {/* Matching Photo Album Link */}
              {(post.countries || []).length > 0 && (
                <div style={{ marginTop: '10px' }}>
                  {photoAlbums.filter(album =>
                    (album.countries || []).some(ac => (post.countries || []).includes(ac))
                  ).slice(0, 1).map(matchingAlbum => (
                    <a
                      key={matchingAlbum.id}
                      href={matchingAlbum.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-info"
                      style={{ fontSize: '14px', borderRadius: '4px' }}
                    >
                      <i className="fa fa-camera"></i> View related photo album: {matchingAlbum.name}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-8 col-lg-offset-2">
            <div
              className="blog-post-content"
              dangerouslySetInnerHTML={{ __html: postContent }}
            />

            <div className="text-center" style={{ marginTop: '30px' }}>
              <Link to="/blog" className="btn btn-primary">
                Back to Blog
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogPost;
